import { Action } from '@ngrx/store';
import { ParameterType } from '../../../_generated';

export enum DataTypeAction {
  Set = '[DataType] Set',
  Reset = '[DataType] Reset',
}

export class Set implements Action {
  readonly type = DataTypeAction.Set;

  constructor(public payload: ParameterType) {}
}

export class Reset implements Action {
  readonly type = DataTypeAction.Reset;
}

export type DataTypeActionType = Set | Reset;
